import { put, takeEvery, takeLatest } from "redux-saga/effects";

import lobbyService from "../../../../services/casino/lobby";
import {
  getAllBonusesStart,
  getAllBonusesSuccess,
  getAllBonusesFailure,
  getBonusStart,
  getBonusSuccess,
  getBonusFailure,
  getAuthUserBonusesStart,
  getAuthUserBonusesSuccess,
  getAuthUserBonusesFailure,
  activateBonusStart,
  activateBonusSuccess,
  activateBonusFailure
} from "../../../redux/casino/lobby/bonus";
import { showErrorMessage, showSuccessMessage } from "../../../redux/toast";

function* bonusWatcher() {
  yield takeLatest(
    [
      getAllBonusesStart.type,
      //   getBonusStart.type,
      getAuthUserBonusesStart.type
    ],
    bonusWorker
  );
  yield takeEvery(activateBonusStart.type, activateBonusWorker);
}

function* bonusWorker(action) {
  try {
    switch (action.type) {
      case getAllBonusesStart.type: {
        const { data, error } = yield lobbyService.getAuthUserBonuses();
        if (!error) {
          yield put(getAllBonusesSuccess(data));
        }
        if (error) {
          yield put(showErrorMessage({ msg: error.message }));
          yield put(getAllBonusesFailure());
        }
        break;
      }
      case getBonusStart.type: {
        const { data, error } = yield lobbyService.getUserBonuses(
          action.payload
        );

          console.log("API FULL RESPONSE:", data);

        if (!error) {
          yield put(getBonusSuccess(data));
        }
        if (error) {
          yield put(showErrorMessage({ msg: error.message }));
          yield put(getBonusFailure());
        }
        break;
      }
      case getAuthUserBonusesStart.type: {
        const { data, error } = yield lobbyService.getAuthUserBonuses(
          action.payload
        );
        if (!error) {
          yield put(getAuthUserBonusesSuccess(data));
        }
        if (error) {
          yield put(showErrorMessage({ msg: error.message }));
          yield put(getAuthUserBonusesFailure());
        }
        break;
      }

      default: {
        break;
      }
    }
  } catch (error) {
    switch (action.type) {
      case getAllBonusesStart.type: {
        yield put(getAllBonusesFailure());
        break;
      }
      case getBonusStart.type: {
        yield put(getBonusFailure());
        break;
      }
      case getAuthUserBonusesStart.type: {
        yield put(getAuthUserBonusesFailure());
        break;
      }
      default: {
        break;
      }
    }
    yield put(showErrorMessage({ msg: error.message }));
  }
}

function* activateBonusWorker(action) {
  try {
    const { data, error } = yield lobbyService.activateBonus(action.payload);

    if (error) {
      yield put(showErrorMessage({ msg: error.message }));
      yield put(activateBonusFailure(error.message || "Something went wrong"));
      return; // stop here
    }

    // If API returned "business error" inside data
    if (data?.status && data.status !== 200) {
      yield put(
        showErrorMessage({ msg: data.message || "Something went wrong" })
      );
      yield put(activateBonusFailure(data.message || "Not eligible"));
      yield put(getAllBonusesStart());
      return;
    }

    // ✅ Success case
    yield put(activateBonusSuccess({ data }));
    yield put(showSuccessMessage({ tKey: "BONUS.BONUS_ACT_MSG" }));
    yield put(getAllBonusesStart());
  } catch (error) {
    yield put(showErrorMessage({ msg: error.message }));
    yield put(activateBonusFailure(error.message || "Something went wrong"));
  }
}

export default bonusWatcher;
